import {
  FETCH_AGENTS_ACTIVE,
  FETCH_AGENTS_ACTIVE_SUCCESS,
  FETCH_AGENTS_INACTIVE,
  FETCH_AGENTS_INACTIVE_SUCCESS,
  FETCH_AGENTS_INVITED,
  FETCH_AGENTS_INVITED_SUCCESS,
  FETCH_AGENTS_ERROR,
  FETCH_AGENTS_LOADING,
  FETCH_AGENT_DETAILS,
  SET_AGENT_DETAILS,
  UPDATE_AGENT,
  UPDATE_AGENT_SUCCESS,
  FETCH_CLIENTS,
  SET_CLIENTS,
  FETCH_CLIENTS_ACTION_REQUIRED,
  SET_CLIENTS_ACTION_REQUIRED,
  EXPORT_CLIENTS,
  EXPORT_CLIENTS_ACTION_REQUIRED,
  FETCH_CLIENT_DETAILS,
  SET_CLIENT_DETAILS,
  INVITE_AGENT,
  INVITE_AGENT_SUCCESS,
  CANCEL_INVITE,
  CANCEL_INVITE_SUCCESS,
  PRINT_CLIENT_FILES,
  DOWNLOAD_CLIENT_FILES,
  ASSIGN_COACH,
  ASSIGN_NEGOTIATOR,
  FETCH_ALL_AGENTS_ACTIVE,
  FETCH_ALL_AGENTS_ACTIVE_SUCCESS,
  ARCHIVE_CLIENT,
  RESEND_INVITATION,
  RESEND_INVITATION_SUCCESS,
  ADD_CLIENT,
} from '@/app/admin/store/types';
import { LOGOUT, REFRESH_REQUEST } from '@/app/auth/store/types';

import { http } from '@/api';

export const actions = {
  [FETCH_AGENTS_ACTIVE]: ({ commit, dispatch }, options) => new Promise((resolve, reject) => {
    commit(FETCH_AGENTS_LOADING);
    http.get(`/admin/agents/search?IsActive=true&OrderBy=${options.orderBy}&Page=${options.page}&Name=${options.filter}&PageSize=10`)
      .then((response) => {
        commit(FETCH_AGENTS_ACTIVE_SUCCESS, response.data);
        resolve(response);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(REFRESH_REQUEST)
            .then(() => {
              // eslint-disable-next-line no-restricted-globals
              location.reload();
            })
            .catch(() => {
              dispatch(LOGOUT);
            });
        } else {
          commit(FETCH_AGENTS_ERROR);
          reject(err);
        }
      });
  }),
  [FETCH_AGENTS_INVITED]: ({ commit, dispatch }, options) => new Promise((resolve, reject) => {
    commit(FETCH_AGENTS_LOADING);
    http.get(`/admin/agents/search?IsInvited=true&OrderBy=${options.orderBy}&Page=${options.page}&Name=${options.filter}&PageSize=10`)
      .then((response) => {
        commit(FETCH_AGENTS_INVITED_SUCCESS, response.data);
        resolve(response);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(REFRESH_REQUEST)
            .then(() => {
              // eslint-disable-next-line no-restricted-globals
              location.reload();
            })
            .catch(() => {
              dispatch(LOGOUT);
            });
        } else {
          commit(FETCH_AGENTS_ERROR);
          reject(err);
        }
      });
  }),
  [FETCH_AGENTS_INACTIVE]: ({ commit, dispatch }, options) => new Promise((resolve, reject) => {
    commit(FETCH_AGENTS_LOADING);
    http.get(`/admin/agents/search?IsInactive=true&OrderBy=${options.orderBy}&Page=${options.page}&Name=${options.filter}&PageSize=10`)
      .then((response) => {
        commit(FETCH_AGENTS_INACTIVE_SUCCESS, response.data);
        resolve(response);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(REFRESH_REQUEST)
            .then(() => {
              // eslint-disable-next-line no-restricted-globals
              location.reload();
            })
            .catch(() => {
              dispatch(LOGOUT);
            });
        } else {
          commit(FETCH_AGENTS_ERROR);
          reject(err);
        }
      });
  }),
  [FETCH_AGENT_DETAILS]: ({ commit, dispatch }, agentId) => new Promise((resolve, reject) => {
    http.get(`/admin/agents/${agentId}`)
      .then((response) => {
        commit(SET_AGENT_DETAILS, response.data);
        resolve(response);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(REFRESH_REQUEST)
            .then(() => {
              // eslint-disable-next-line no-restricted-globals
              location.reload();
            })
            .catch(() => {
              dispatch(LOGOUT);
            });
        } else {
          commit(FETCH_AGENTS_ERROR);
          reject(err);
        }
      });
  }),
  [UPDATE_AGENT]: ({ commit }, data) => new Promise((resolve, reject) => {
    http.put(`/admin/agents/${data.agentId}`, JSON.stringify(data.updateData))
      .then((response) => {
        commit(UPDATE_AGENT_SUCCESS, data);
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  }),
  [FETCH_CLIENTS]: ({ commit }, options) => new Promise((resolve, reject) => {
    let queryString = `/admin/clients/search?OrderBy=${options.orderBy}&Page=${options.page}&PageSize=10`;
    if (options.filter) {
      queryString = `/admin/clients/search?OrderBy=${options.orderBy}&Page=${options.page}&PageSize=10&${options.filter.filterName}=${options.filter.filterQuery}`;
    }
    http.get(queryString)
      .then((response) => {
        commit(SET_CLIENTS, response.data);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  }),
  [FETCH_CLIENTS_ACTION_REQUIRED]: ({ commit }, options) => new Promise((resolve, reject) => {
    let queryString = `/admin/clients/search?IsActionRequired=true&OrderBy=${options.orderBy}&Page=${options.page}&PageSize=10`;
    if (options.filter) {
      queryString = `/admin/clients/search?IsActionRequired=true&OrderBy=${options.orderBy}&Page=${options.page}&PageSize=10&${options.filter.filterName}=${options.filter.filterQuery}`;
    }
    http.get(queryString)
      .then((response) => {
        commit(SET_CLIENTS_ACTION_REQUIRED, response.data);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  }),
  [EXPORT_CLIENTS]: ({ dispatch }, options) => new Promise((resolve, reject) => {
    let queryString = '/admin/clients/search/export';
    if (options.filter) {
      queryString = `/admin/clients/search/export?${options.filter.filterName}=${options.filter.filterQuery}`;
    }
    http.get(queryString, {
      responseType: 'blob',
    })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(REFRESH_REQUEST)
            .then(() => {
              dispatch(EXPORT_CLIENTS);
            });
        } else {
          reject(err);
        }
      });
  }),
  [EXPORT_CLIENTS_ACTION_REQUIRED]: ({ dispatch }, options) => new Promise((resolve, reject) => {
    let queryString = '/admin/clients/search/export?IsActionRequired=true';
    if (options.filter) {
      queryString = `/admin/clients/search/export?IsActionRequired=true&${options.filter.filterName}=${options.filter.filterQuery}`;
    }
    http.get(queryString, {
      responseType: 'blob',
    })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(REFRESH_REQUEST)
            .then(() => {
              dispatch(EXPORT_CLIENTS_ACTION_REQUIRED);
            });
        } else {
          reject(err);
        }
      });
  }),
  [FETCH_CLIENT_DETAILS]: ({ commit, dispatch }, appId) => new Promise((resolve, reject) => {
    http.get(`/admin/clients/${appId}`)
      .then((response) => {
        commit(SET_CLIENT_DETAILS, response.data);
        resolve(response);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(REFRESH_REQUEST)
            .then(() => {
            // eslint-disable-next-line no-restricted-globals
              location.reload();
            })
            .catch(() => {
              dispatch(LOGOUT);
            });
        } else {
          reject(err);
        }
      });
  }),
  [PRINT_CLIENT_FILES]: ({ dispatch }, appId) => new Promise((resolve, reject) => {
    http.get(`/admin/clients/${appId}/print`, {
      responseType: 'blob',
    })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(REFRESH_REQUEST)
            .then(() => {
              dispatch(PRINT_CLIENT_FILES);
            });
        } else {
          reject(err);
        }
      });
  }),
  [DOWNLOAD_CLIENT_FILES]: ({ dispatch }, appId) => new Promise((resolve, reject) => {
    http.get(`/admin/clients/${appId}/download`, {
      responseType: 'blob',
    })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(REFRESH_REQUEST)
            .then(() => {
              dispatch(DOWNLOAD_CLIENT_FILES);
            });
        } else {
          reject(err);
        }
      });
  }),
  [INVITE_AGENT]: ({ commit }, agentData) => new Promise((resolve, reject) => {
    commit(FETCH_AGENTS_LOADING);
    http.post('/admin/agents/invite', agentData)
      .then((response) => {
        commit(INVITE_AGENT_SUCCESS);
        resolve(response);
      })
      .catch((err) => {
        commit(FETCH_AGENTS_ERROR);
        reject(err);
      });
  }),
  [CANCEL_INVITE]: ({ commit }, agentEmail) => new Promise((resolve, reject) => {
    commit(FETCH_AGENTS_LOADING);
    http.post('/admin/agents/cancel', agentEmail)
      .then((response) => {
        commit(CANCEL_INVITE_SUCCESS);
        resolve(response);
      })
      .catch((err) => {
        commit(FETCH_AGENTS_ERROR);
        reject(err);
      });
  }),

  // eslint-disable-next-line no-empty-pattern
  [ASSIGN_COACH]: ({}, assignData) => new Promise((resolve, reject) => {
    http.put(`/admin/clients/${assignData.clientAppId}/assign-coach/${assignData.agentId}`)
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  }),
  // eslint-disable-next-line no-empty-pattern
  [ASSIGN_NEGOTIATOR]: ({}, assignData) => new Promise((resolve, reject) => {
    http.put(`/admin/clients/${assignData.clientAppId}/assign-negotiator/${assignData.agentId}`)
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  }),
  [FETCH_ALL_AGENTS_ACTIVE]: ({ commit, dispatch }) => new Promise((resolve, reject) => {
    http.get('/admin/agents/search?IsActive=true')
      .then((response) => {
        commit(FETCH_ALL_AGENTS_ACTIVE_SUCCESS, response.data);
        resolve(response);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(REFRESH_REQUEST)
            .then(() => {
              // eslint-disable-next-line no-restricted-globals
              location.reload();
            })
            .catch(() => {
              dispatch(LOGOUT);
            });
        } else {
          reject(err);
        }
      });
  }),
  // eslint-disable-next-line no-empty-pattern
  [ARCHIVE_CLIENT]: ({}, clientId) => new Promise((resolve, reject) => {
    http.post(`admin/clients/${clientId}/archive`)
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  }),
  [RESEND_INVITATION]: ({ commit }, agentEmail) => new Promise((resolve, reject) => {
    commit(FETCH_AGENTS_LOADING);
    http.post('/admin/agents/resend', agentEmail)
      .then((response) => {
        commit(RESEND_INVITATION_SUCCESS);
        resolve(response);
      })
      .catch((err) => {
        commit(FETCH_AGENTS_ERROR);
        reject(err);
      });
  }),
  // eslint-disable-next-line no-empty-pattern
  [ADD_CLIENT]: ({}, clientData) => new Promise((resolve, reject) => {
    http.post('/admin/clients', clientData)
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  }),
};
